import { brands } from '@/content/et/brands';
import { site } from '@/content/et/site';
import styles from './BrandShowcase.module.css';

function BrandRow({
  suffix,
  decorative,
}: {
  suffix: string;
  decorative?: boolean;
}) {
  return (
    <ul className={styles.track} aria-hidden={decorative || undefined}>
      {brands.map((brand) => (
        <li key={`${suffix}-${brand.id}`} className={styles.slot}>
          {brand.logoSrc ? (
            <img
              src={brand.logoSrc}
              alt={decorative ? '' : brand.name}
              className={styles.logo}
              width={160}
              height={64}
              loading="lazy"
              decoding="async"
            />
          ) : (
            <span className={styles.wordmark}>{brand.name}</span>
          )}
        </li>
      ))}
    </ul>
  );
}

export function BrandShowcase() {
  return (
    <section
      id="brandid"
      className={`section ${styles.section}`}
      aria-labelledby="brandid-title"
    >
      <div className="container">
        <header className="section__header">
          <h2
            id="brandid-title"
            className="section__title section__title--tight"
          >
            {site.brands.title}
          </h2>
        </header>
      </div>

      <div className={styles.marquee} aria-label={site.brands.title}>
        <div className={styles.marqueeInner}>
          <BrandRow suffix="a" />
          <BrandRow suffix="b" decorative />
        </div>
      </div>
    </section>
  );
}
